import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getPullTariffsDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/inputs/tariffs/pull-tariffs.form-default-values';
import { PullTariffsModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/inputs/tariffs/pull-tariffs.model';
import { useState } from 'react';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';
import { useEmspBoPullTariffsMutation } from '@service/emsp-bo-tariff.service';

import { PullEmspBoTariffContextProvider } from '../emsp-bo-tariff.context';
import { EmspBoTariffPullCreateFormController } from './emsp-bo-tariff-pull-create-form/emsp-bo-tariff-pull-create-form.controller';

interface EmspBoTariffPullCreateControllerProps {
  cpoId: string;
  onCancel: () => void;
  onSuccess: () => void;
}

export const EmspBoTariffPullCreateController = ({
  cpoId,
  onCancel,
  onSuccess,
}: EmspBoTariffPullCreateControllerProps): React.JSX.Element => {
  const { t } = useTranslation();
  const [pullTariffsMutation] = useEmspBoPullTariffsMutation();
  const [multiStepFormState, setMultiStepFormState] = useState(
    MultiStepFormState.Default,
  );

  const handleError: SubmitErrorHandler<PullTariffsModel> = (errors) => {
    Logger.error(errors);
    toast.error(
      t('$.emsp-bo-tariff-pull-create.error', {
        error: t('global.unknown'),
      }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<PullTariffsModel> = (
    fieldValues,
  ) => {
    setMultiStepFormState(MultiStepFormState.Loading);

    pullTariffsMutation(fieldValues)
      .unwrap()
      .then(() => {
        toast.success(t('$.emsp-bo-tariff-pull-create.success'));
        onSuccess();
      })
      .catch((err) => {
        toast.error(
          t('$.emsp-bo-tariff-pull-create.error', {
            error: err?.data?.message ?? t('global.unknown'),
          }),
        );
      })
      .finally(() => setMultiStepFormState(MultiStepFormState.Default));
  };

  const data = getPullTariffsDefaultValues(cpoId);

  return (
    <PullEmspBoTariffContextProvider data={data}>
      <EmspBoTariffPullCreateFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
        state={multiStepFormState}
      />
    </PullEmspBoTariffContextProvider>
  );
};
